// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3BLEb","label":"styles_label__3NLBK"};